// @ts-nocheck
import constants from "@store/constants";

const ROLES_WITH_APPROVERS = [constants.userRole.buyer1, constants.userRole.buyer2];
const BUYER_ROLES = [constants.userRole.buyer1, constants.userRole.buyer2, constants.userRole.buyer3];

const roleRequiresApprover = (userRole: string) => ROLES_WITH_APPROVERS.includes(userRole);
const isBuyerRole = (userRole: string) => BUYER_ROLES.includes(userRole);
const isAdministratorRole = (userRole: string) => userRole.includes(constants.userRole.administrator);

export { roleRequiresApprover, isBuyerRole, isAdministratorRole };
